module.exports = {"scholar":{"label":"Current scholar level","primary":"Primary","secondary":"Secondary","post-secondary":"Post-secondary","nonapplicable":"Non applicable"}}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/scholarlevels.json
// module id = bP2C
// module chunks = 17